var app = angular.module("nms.dynamicDevice");

app.directive("integer",
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/domain/yang/leaf/types/numbers/integer.html"
        };
    }
);
